import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric } from 'src/app/shared';
import { AffCodeTypeSearchDto } from './dto/aff-code-type-search.dto';
import { AffCodeType } from './affcode-type.model';

@Injectable({
  providedIn: 'root',
})
export class AffCodeTypeService {
  constructor(private _apiService: ApiService) {}

  search(searchDto: AffCodeTypeSearchDto, forceRefresh = false): Promise<PagedResultGeneric<AffCodeType>> {
    let cacheOptions = null;
    if (forceRefresh) {
      cacheOptions = this._apiService.getDefaultApiCacheOptionsForNoCache();
    }
    return this._apiService.getPaged('AffCodeTypes', searchDto, cacheOptions);
  }

  get(id: number): Promise<AffCodeType> {
    return this._apiService.get(`AffCodeType/${id}`);
  }

  create(dto: AffCodeType): Promise<number> {
    return this._apiService.post('AffCodeTypes', dto);
  }

  update(dto: AffCodeType): Promise<void> {
    return this._apiService.put(`AffCodeType/${dto.AffCodeTypeID}`, dto);
  }

  delete(id: number): Promise<void> {
    return this._apiService.delete(`AffCodeType/${id}`);
  }
}
